<template>
    <div id="createPoint-tool-button" v-on:click="componentClick">
        <img ref='createPointToolButtonImage' :src="imageSrc"
             alt="Point" :class="current">
    </div>
</template>

<style scoped>
img {
    width: 100%;
    height: 100%;
}
</style>

<script>
import createpointToolMachine from "./createpoint-tool-xstate";
import BaseTool from "../base-tool";
import hinter from "../move/move-hints";

import createPointIconSelected from "./createpoint-icon-selected.png";
import createPointIcon from "./createpoint-icon.png";
import cabri from "../../app/cabri-app";
import {LOG} from '../../app/log'
import toolMachine from "../button-based-tool-xstate";

const imgSrc = {
    selected: createPointIconSelected,
    available_but_invisible: createPointIconSelected,
    rollover_nothing: createPointIconSelected,
    rollover_movable: createPointIconSelected,
    object_moving_horizontal: createPointIconSelected,
    object_moving_vertical: createPointIconSelected,
    finished: createPointIcon,
    inactive: createPointIcon
};

const base = new BaseTool();

let name = "createPoint-tool";
export default {
    name: "createPoint-tool",
    created () {
        base.init(this, imgSrc);
        base.created();
        window.createpointToolCC = this;
        window.theCreatepointEngine = base.ref.stateEngine;
    },
    data () {
        return base.data(createpointToolMachine, name);
    },
    mounted: base.mounted,

    methods: {
        sendToStateEngine (trsn) {
            base.sendToStateEngine(trsn, this);
        },
        componentClick: (event) => {
            base.ref.sendToStateEngine("ACTIVATE", this);
        },
        stateChanged (state) {
            LOG.for("createpoint-tool-comp") && LOG.info("CreatePoint Engine state: ", state);
            cabri.highlightingActive = !(state === toolMachine.initialState.value);
            hinter.stateChanged(state);
        },
        handlePointer (pointerInfo) {
            let h = cabri.gestureHandler;
            let state = base.ref.current;
            let touchedGeomObject =
                pointerInfo.pickInfo && pointerInfo.pickInfo.pickedMesh
                && pointerInfo.pickInfo.pickedMesh.cabriPeer
                ? pointerInfo.pickInfo.pickedMesh.cabriPeer : null;
            window.thelastPointerInfo = pointerInfo;
            switch (pointerInfo.type) {
                // TODO: Detect if left click and only then continue
                case BABYLON.PointerEventTypes.POINTERDOWN:
                    LOG.for("createpoint-tool-comp") && LOG.info("POINTER DOWN", touchedGeomObject);
                    if (touchedGeomObject) {
                        base.ref.stateEngine.send({type: "STARTCREATE", touchedGeomObject: touchedGeomObject, pointerInfo: pointerInfo});
                    }
                    break;
                case BABYLON.PointerEventTypes.POINTERMOVE:
                    const evt = {pointerInfo: pointerInfo, touchedGeomObject: touchedGeomObject};
                    if (state.startsWith("point_moving_")) {
                        evt.type = "MOVE";
                    } else if(state==="rollover_nothing" && touchedGeomObject) {
                        evt.type = "MEET";
                    } else if(state==="rollover_movable" && touchedGeomObject === null) {
                        evt.type = "LEAVE";
                    }
                    if(evt.type) {
                        base.ref.stateEngine.send(evt);
                    }
                    break;
                case BABYLON.PointerEventTypes.POINTERUP:
                    LOG.for("createpoint-tool-comp") && LOG.info("POINTER UP");
                    base.ref.stateEngine.send("DROP");
                    h.lastMousePos = null;
                    break;
                default:
                    h.lastMousePos = null;
            }

            let moved = false;

            if (base.ref.stateEngine.current === "point_moving_horizontal"
                || base.ref.stateEngine.current ===  "point_moving_vertical") {
                h.lastMousePos =
                    [pointerInfo.event.clientX, pointerInfo.event.clientY];

            }

        },
        handleDirChange(shouldMoveVertically) {
            base.ref.stateEngine.send({type: "CHANGE_DIR"});
        }
    },
    public: {},

};

</script>